module.exports = "<p>\r\n  filter works!\r\n</p>\r\n"